import React from 'react';
import ConvocationPageShell from '../../components/ConvocationPageShell';
import MiyunimStatic from './MiyunimStatic';

const Miyunim = () => (
  <ConvocationPageShell
    strapiApiId="convocation-miyunim"
    defaultTitle="Miyunim"
    StaticFallback={MiyunimStatic}
  />
);

export default Miyunim;
